// src/views/scannedData/useScans.js
import { useEffect, useState } from "react";
import { subscribeToScans } from "../services/scansService";

export default function useScans(user, viewUserID) {
  const [scans, setScans] = useState([]);

  useEffect(() => {
    if (!user?.email && !viewUserID) return;

    const userPath = viewUserID || user.email.replaceAll(".", "-");
    return subscribeToScans(userPath, setScans);
  }, [user, viewUserID]);

  return scans;
}
